import React from 'react'
import { Avatar, Box, makeStyles, Typography } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import { BuildingFragment } from '../../generated/graphql'
import { SystemContainerList } from '../system-container/SystemContainerList'
import { formatArea } from '../../util/formatters'
import { IndicatorIcons } from './indicator-icons/IndicatorIcons'

const useStyles = makeStyles((theme) => ({
  additionalInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: theme.spacing(3),
  },
  type: {
    color: theme.palette.grey[500],
  },
  name: {
    ...theme.typography.h5,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
}))

type Props = {
  buildings: BuildingFragment[]
  onBuildingClick: (building: BuildingFragment) => void
}

export function BuildingList({
  buildings,
  onBuildingClick,
}: Props): React.ReactElement {
  const classes = useStyles()
  const { t } = useTranslation()

  return (
    <SystemContainerList
      items={buildings}
      idGetter={(building) => building.id}
      renderItem={(building) => (
        <>
          <Box mb={3}>
            <Box className={classes.additionalInfo}>
              <Typography className={classes.type}>
                {t(`buildingType.${building.type}`)},{' '}
                {formatArea(building.area)}
              </Typography>
              {building.multiplier !== 1 && (
                <Avatar>x{building.multiplier}</Avatar>
              )}
            </Box>

            <Typography className={classes.name}>{building.name}</Typography>
          </Box>

          <Box ml={-2}>
            <IndicatorIcons building={building} />
          </Box>
        </>
      )}
      onItemClick={onBuildingClick}
    />
  )
}
